'use client';

import { useEffect } from 'react';

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('RootError:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gray-50 text-gray-900">
      <h1 className="text-xl font-semibold mb-2">Une erreur est survenue</h1>
      <p className="text-gray-600 text-sm mb-4 max-w-md text-center">
        {error.message || 'Erreur inconnue'}
      </p>
      <button
        type="button"
        onClick={reset}
        className="px-4 py-2 rounded-md bg-black text-white hover:opacity-90"
      >
        Réessayer
      </button>
    </div>
  );
}
